import { useState, useEffect } from 'react'
import { useAuthManager } from "./useAuthManager";
import { JsonApiError } from '../../utils/errors'

export function useValidateCode(code: string, email: string, expiryDate: string | null) {
  const { login } = useAuthManager()
  const [isValidCode, setIsValidCode] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  useEffect(() => {
    function validateCode() {
      const dateIsExpired = !expiryDate || new Date() >= new Date(expiryDate)
      if (dateIsExpired) {
        setIsValidCode(false)
        setIsLoading(false)
        return
      }
      login(
        { email: email ?? '', password: code ?? '' },
        {
          onSuccess: () => {
            setIsValidCode(true)
            setIsLoading(false)
          },
          onError: err => {
            if (
              err instanceof JsonApiError &&
              err.status === 403 &&
              err.code === 'new_password_required'
            ) {
              setIsValidCode(true)
              setIsLoading(false)
            } else {
              setIsValidCode(false)
              setIsLoading(false)
            }
          },
        },
      )
    }
    validateCode()
  }, [email, code, expiryDate, login])
  return { isValidCode, isLoading }
}
